import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Tooltip } from "@mui/material";
import ReactSwitch from "react-switch";

import { AppDispatch } from "../../../../../../redux/store";
import { setActiveFidelity } from "../../../../../../redux/slices/fidelitySlice";

type Props = {
    element: any;
    selectedFidelity: any[];
    isOneShopClicked: boolean;
};

function resolveInitialState(
    element: any,
    selectedFidelity: any[],
    isOneShopClicked: boolean
): boolean {
    if (!isOneShopClicked) return true;
    const match = selectedFidelity.find(
        (el: any) => el.Id === element.selectedRow.Id
    );
    return match ? match.isActive : true;
}

export default function FidelityRowSwitch({
    element,
    isOneShopClicked,
    selectedFidelity,
}: Props) {
    const { t } = useTranslation();
    const dispatch = useDispatch<AppDispatch>();
    const [fidelityState, setFidelityState] = React.useState<boolean>(
        resolveInitialState(element, selectedFidelity, isOneShopClicked)
    );

    React.useEffect(() => {
        dispatch(
            setActiveFidelity({
                Id: element.selectedRow.Id,
                state: fidelityState,
            })
        );
        // eslint-disable-next-line
    }, [fidelityState]);

    if (element.selectedRow?.subRows !== undefined) return null;

    return (
        <div className="d-flex justify-content-around fed_icn_AFenableDisable">
            <Tooltip
                title={fidelityState ? t("Unactivate") : t("Activate")}
            >
                <div>
                    <ReactSwitch
                        data-testid={`fidelity-shops-associate-activate-switch-${element.selectedRow.Id}`}
                        uncheckedIcon={false}
                        checkedIcon={false}
                        handleDiameter={26}
                        offColor="#f7b4b8"
                        offHandleColor="#E30613"
                        checked={fidelityState}
                        onChange={() => setFidelityState(!fidelityState)}
                        onColor="#c2eddd"
                        onHandleColor="#34C38F"
                        width={50}
                        height={20}
                    />
                </div>
            </Tooltip>
        </div>
    );
}
